export default (el) => {

  $(el).find('.trigger').on('click', ({ currentTarget }) => {

    const $trigger = $(currentTarget),
          target   = $trigger.attr('aria-controls'),
          $content = $(`#${target}`);

    $trigger.attr('aria-expanded', $trigger.attr('aria-expanded') === 'true' ? 'false' : 'true');
    $content.attr('aria-hidden', $content.attr('aria-hidden') === 'true' ? 'false' : 'true');

  });

};